<template>
  <v-app class="app">
    <div class="header_buffer" />
    <div class="top_header">
      <div class="header_contact">
        <a
          class="header_tel"
          href="https://support.havebike.co.uk">
          <font-awesome-icon class="mr-1" :icon="['fas', 'phone']" /> Contact Support
        </a>
      </div>
    </div>
    <div class="header">
      <a :href="webUrl">
        <img
          class="logo"
          src="./assets/tredz-havebike-lockoff.png"
        >
      </a>
    </div>
    <v-container class="mb-5">
      <router-view/>
    </v-container>
    <div class="app_version">
      <p>havebike Booking Engine vT3.2.3</p>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  computed: {
    webUrl () {
      return process.env.VUE_APP_WEB_URL
    }
  }
}
</script>

<style type="text/css">
  :root {
    --theme-primary: #d92326;
    --theme-background: #f7f7f7;
  }
  .app {
    background: var(--theme-background) !important;
  }
  .logo {
    max-width: 300px;
  }
  .header_buffer {
    height: 140px;
  }
  .header_contact {
    margin-left: 30px;
    display: block;
    position: relative;
    z-index: 101;
  }
  .header_tel {
    color: white!important;
    text-decoration: none;
    font-size: 14px!important;
  }
  .header_tel:hover {
    text-decoration: underline;
  }
  .top_header {
    background: var(--theme-primary);
    padding: 5px 0px;
    position: fixed;
    width: 100%;
    z-index: 100;
  }
  .header {
    top: 35px;
    z-index: 101;
    padding: 15px 30px 10px 30px;
    background: white;
    box-shadow: 0 1px 2px 0 rgba(161,161,161,0.25);
    position: fixed;
    width: 100%;
  }
  .app_version {
    position: absolute;
    bottom: 0px;
    font-size: 12px;
    color: grey;
    padding: 0px 0px 0px 10px;
    display: block;
  }
</style>
